const RAW = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${RAW.replace(/\/$/, "")}/api`;

async function jfetch(path, opts = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {}),
    },
  });
  const isJson = (res.headers.get("content-type") || "").includes("application/json");
  const body = isJson ? await res.json().catch(() => ({})) : await res.text();
  if (!res.ok) {
    const msg =
      (body && (body.detail || body.message)) ||
      (typeof body === "string" ? body : `HTTP ${res.status}`);
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return body;
}

export const api = {
  content: () => jfetch("/content"),
  imageVersions: () => jfetch("/image-versions"),
  chat: (session_id, messages) =>
    jfetch("/chat", {
      method: "POST",
      body: JSON.stringify({ session_id, messages }),
    }),
  vipCheck: (password) =>
    jfetch("/vip/check", {
      method: "POST",
      body: JSON.stringify({ password }),
    }),

  // Admin
  adminLogin: (password) =>
    jfetch("/admin/login", {
      method: "POST",
      body: JSON.stringify({ password }),
    }),
  adminLogout: () => jfetch("/admin/logout", { method: "POST" }),
  adminSession: () => jfetch("/admin/session"),
  adminGetContent: () => jfetch("/admin/content"),
  adminSaveContent: (updates) =>
    jfetch("/admin/content", {
      method: "POST",
      body: JSON.stringify(updates),
    }),
  adminGetSettings: () => jfetch("/admin/settings"),
  adminSaveSettings: (updates) =>
    jfetch("/admin/settings", {
      method: "POST",
      body: JSON.stringify(updates),
    }),
  adminUploadGallery: async (slot, file) => {
    const fd = new FormData();
    fd.append("slot", slot);
    fd.append("file", file);
    const res = await fetch(`${API_BASE}/admin/gallery/upload`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    const j = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(j.detail || `HTTP ${res.status}`);
    return j;
  },
  adminChats: () => jfetch("/admin/chats"),
  adminChat: (id) => jfetch(`/admin/chats/${id}`),
  adminDeleteChat: (id) => jfetch(`/admin/chats/${id}`, { method: "DELETE" }),
  adminAnalyticsCtr: (days = 30) =>
    jfetch(`/admin/analytics/whatsapp-ctr?days=${days}`),
  adminAnalyticsClicks: (days = 30) =>
    jfetch(`/admin/analytics/clicks?days=${days}`),

  // VIP codes
  adminListVipCodes: () => jfetch("/admin/vip-codes"),
  adminCreateVipCode: (body) =>
    jfetch("/admin/vip-codes", { method: "POST", body: JSON.stringify(body) }),
  adminDeleteVipCode: (code) =>
    jfetch(`/admin/vip-codes/${code}`, { method: "DELETE" }),

  // Referral codes
  adminListReferrals: () => jfetch("/admin/referral-codes"),
  adminCreateReferral: (body) =>
    jfetch("/admin/referral-codes", { method: "POST", body: JSON.stringify(body) }),
  adminMarkReferralUsed: (code, note) =>
    jfetch(`/admin/referral-codes/${code}/mark-used`, {
      method: "POST",
      body: JSON.stringify({ note }),
    }),
  adminDeleteReferral: (code) =>
    jfetch(`/admin/referral-codes/${code}`, { method: "DELETE" }),

  // Reviews
  adminCreateReviewToken: (body) =>
    jfetch("/admin/reviews/token", { method: "POST", body: JSON.stringify(body || {}) }),
  adminListReviewTokens: () => jfetch("/admin/reviews/tokens"),
  adminListPendingReviews: () => jfetch("/admin/reviews/pending"),
  adminApproveReview: (id) =>
    jfetch(`/admin/reviews/pending/${id}/approve`, { method: "POST" }),
  adminRejectReview: (id) =>
    jfetch(`/admin/reviews/pending/${id}/reject`, { method: "POST" }),
  publicReviewToken: (token) => jfetch(`/review/${token}`),
  publicReviewSubmit: (token, body) =>
    jfetch(`/review/${token}/submit`, { method: "POST", body: JSON.stringify(body) }),
};
